/* eslint-disable no-useless-escape */

/* eslint-disable max-len */
import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { _getKeyValue_ } from '../getObjectKeyValue';
import icoValidation from './icoValidation';
import icoZahranicnyValidation from './icoZahranicnyValidation';

const commonRegEx = '^((HRA|HRB|HRV|GnR|VR|PR)\\s\\d{1,8})(\\s?[A-ZÜÖÄ]{1,3})?$';

const CZSKrejstrikVals = [
    'RA000163',
    'RA000164',
    'RA000165',
    'RA000166',
    'RA000167',
    'RA000168',
    'RA000694'
    /* 'RA000526',
    'RA000527',
    'RA000528',
    'RA000670',
    'RA000671',
    'RA000672',
    'RA000673',
    'RA000674',
    'RA000675',
    'RA000676',
    'RA000677',
    'RA000706' */
];

const leiRejstrikRegExp = {
    RA000001: '^[0-9]{1,6}$',
    RA000013: '^[0-9]{2}\\s[0-9]{3}\\s[0-9]{3}\\s[0-9]{3}$',
    RA000014: '^[0-9]{3}\\s[0-9]{3}\\s[0-9]{3}$',
    RA000015: '^[0-9]{3}\\s[0-9]{3}\\s[0-9]{3}$',
    RA000017: '^(\\d{1,6})$|^(\\d{1,6})\\s?([a-z])$|^(\\d{9,10})$|^(\\d{8,13})$',
    RA000025: '^(BE\\d{10})$|^(\\d{9,10})$|^(\\d{3,4}\\.\\d{3}\\.\\d{3})$',
    RA000059: '^(\\d{11})$|^(\\d{3}\\.\\d{3}\\.\\d{3}\\-\\d{2})$|^(\\d{2}\\.\\d{3}\\.\\d{3}\\/\\d{1,4}\\-\\d{2})$',
    RA000065: '^(\\d{9})$',
    RA000072: '^(\\d{6,7}-\\d{1})$|^(\\d{7,8})$|^(\\d{9}[A-Z]{2}\\d{4})$',
    RA000073: '^(\\d{9,10})$|^[A-Z0-9]{10}$',
    RA000079: '^(\\d{4,10})$',
    RA000081: '^(\\d{10})$',
    RA000082: '^(\\d{9}|\\d{6})$',
    RA000087: '^(\\d{1,7})$',
    RA000156: '^(\\d{9,11})$',
    RA000161: '^((Σ\\s?\\Η\\Ε\\d{1,6})|([Α-Ω\\Η\\Ε]{2}\\s?\\d{1,6}))$',
    RA000163: '^(\\d{8})$|^(\\d{3}\\s\\d{2}\\s\\d{3})$',
    RA000164: '^(\\d{8})$',
    RA000165: '^(\\d{8})$',
    RA000166: '^(\\d{8})$',
    RA000167: '^(\\d{8})$',
    RA000168: '^(\\d{8})$',
    RA000170: '^(\\d{8})$',
    RA000171: '^((\\d{5})|(\\d{5}-\\d{3}))$',
    RA000181: '^(\\d{8})$',
    RA000188: '^(\\d{7}-\\d{1})$|^(\\d{8})$',
    RA000189: '^(\\d{9})$|^(\\d{3}\\s\\d{3}\\s\\d{3})$',
    RA000197: commonRegEx,
    RA000200: commonRegEx,
    RA000201: commonRegEx,
    RA000203: commonRegEx,
    RA000204: commonRegEx,
    RA000205: commonRegEx,
    RA000206: commonRegEx,
    RA000207: commonRegEx,
    RA000208: commonRegEx,
    RA000209: commonRegEx,
    RA000210: commonRegEx,
    RA000213: commonRegEx,
    RA000215: commonRegEx,
    RA000216: commonRegEx,
    RA000217: commonRegEx,
    RA000218: commonRegEx,
    RA000219: commonRegEx,
    RA000220: commonRegEx,
    RA000221: commonRegEx,
    RA000222: commonRegEx,
    RA000224: commonRegEx,
    RA000225: commonRegEx,
    RA000226: commonRegEx,
    RA000227: commonRegEx,
    RA000228: commonRegEx,
    RA000229: commonRegEx,
    RA000230: commonRegEx,
    RA000231: commonRegEx,
    RA000232: commonRegEx,
    RA000233: commonRegEx,
    RA000234: commonRegEx,
    RA000235: commonRegEx,
    RA000236: commonRegEx,
    RA000238: commonRegEx,
    RA000239: commonRegEx,
    RA000240: commonRegEx,
    RA000241: commonRegEx,
    RA000242: commonRegEx,
    RA000243: commonRegEx,
    RA000244: commonRegEx,
    RA000245: commonRegEx,
    RA000246: commonRegEx,
    RA000247: commonRegEx,
    RA000248: commonRegEx,
    RA000249: commonRegEx,
    RA000251: commonRegEx,
    RA000252: commonRegEx,
    RA000253: commonRegEx,
    RA000255: commonRegEx,
    RA000257: commonRegEx,
    RA000258: commonRegEx,
    RA000259: commonRegEx,
    RA000260: commonRegEx,
    RA000261: commonRegEx,
    RA000262: commonRegEx,
    RA000263: commonRegEx,
    RA000266: commonRegEx,
    RA000267: commonRegEx,
    RA000268: commonRegEx,
    RA000269: commonRegEx,
    RA000270: commonRegEx,
    RA000271: commonRegEx,
    RA000272: commonRegEx,
    RA000273: commonRegEx,
    RA000274: commonRegEx,
    RA000275: commonRegEx,
    RA000276: commonRegEx,
    RA000277: commonRegEx,
    RA000278: commonRegEx,
    RA000279: commonRegEx,
    RA000280: commonRegEx,
    RA000281: commonRegEx,
    RA000282: commonRegEx,
    RA000283: commonRegEx,
    RA000284: commonRegEx,
    RA000285: commonRegEx,
    RA000286: commonRegEx,
    RA000287: commonRegEx,
    RA000288: commonRegEx,
    RA000289: commonRegEx,
    RA000290: commonRegEx,
    RA000291: commonRegEx,
    RA000292: commonRegEx,
    RA000293: commonRegEx,
    RA000295: commonRegEx,
    RA000296: commonRegEx,
    RA000297: commonRegEx,
    RA000298: commonRegEx,
    RA000299: commonRegEx,
    RA000300: commonRegEx,
    RA000301: commonRegEx,
    RA000302: commonRegEx,
    RA000303: commonRegEx,
    RA000304: commonRegEx,
    RA000305: commonRegEx,
    RA000306: commonRegEx,
    RA000307: commonRegEx,
    RA000308: commonRegEx,
    RA000309: commonRegEx,
    RA000310: commonRegEx,
    RA000311: commonRegEx,
    RA000312: commonRegEx,
    RA000313: commonRegEx,
    RA000314: commonRegEx,
    RA000315: commonRegEx,
    RA000316: commonRegEx,
    RA000317: commonRegEx,
    RA000319: commonRegEx,
    RA000320: commonRegEx,
    RA000321: commonRegEx,
    RA000322: commonRegEx,
    RA000324: commonRegEx,
    RA000325: commonRegEx,
    RA000326: commonRegEx,
    RA000328: commonRegEx,
    RA000329: commonRegEx,
    RA000330: commonRegEx,
    RA000331: commonRegEx,
    RA000332: commonRegEx,
    RA000333: commonRegEx,
    RA000336: commonRegEx,
    RA000337: commonRegEx,
    RA000338: commonRegEx,
    RA000339: commonRegEx,
    RA000340: commonRegEx,
    RA000341: commonRegEx,
    RA000343: commonRegEx,
    RA000345: commonRegEx,
    RA000347: commonRegEx,
    RA000348: commonRegEx,
    RA000349: commonRegEx,
    RA000350: commonRegEx,
    RA000351: commonRegEx,
    RA000352: commonRegEx,
    RA000353: commonRegEx,
    RA000354: commonRegEx,
    RA000355: commonRegEx,
    RA000356: commonRegEx,
    RA000358: commonRegEx,
    RA000360: commonRegEx,
    RA000362: commonRegEx,
    RA000363: commonRegEx,
    RA000364: commonRegEx,
    RA000365: commonRegEx,
    RA000368: commonRegEx,
    RA000369: commonRegEx,
    RA000370: commonRegEx,
    RA000371: commonRegEx,
    RA000372: commonRegEx,
    RA000378: '^(\\d{8})$',
    RA000383: '^(\\d{1,6})$',
    RA000388: '^([A-Z]{2}\\d{7})$|^([A-Z]{1}\\d{7})$|^(\\d{7})$',
    RA000391: '^(\\d{8})$|^(\\d{2}-\\d{2}-\\d{6})$',
    RA000393: '^(\\d{10})$|^(\\d{6}-\\d{4})$',
    RA000394:
        '^(((L|U)\\d{5}[A-Za-z]{2}\\d{4}[A-Za-z]{3}\\d{6})|([A-Za-z]{3}-\\d{4})|(F\\d{5})|(F[A-Za-z]{3}-\\d{4}))$',
    RA000402: '^(\\d{3,7})$',
    RA000403: '^(\\d{4,7})$',
    RA000404: '^(C\\d{5,7}|^\\d{1,3}CU)$',
    RA000405: '^(\\d{6}[A-Z])$',
    RA000406: '^(\\d{9})$',
    RA000407:
        '^((\\d{9})|([A-Z]{2}\\s?-\\s?\\d{2,8})|(\\d{7,11})|(\\d{11,16})|([A-Z]{6}\\d{2}[A-Z]\\d{2}[A-Z]\\d{3}[A-Z])|(\\d{11})|([A-Z]{6}\\d{2}[A-Z]\\d{2}[A-Z][A-Z0-9]{3}[A-Z]))$',
    RA000414: '^(\\d{1,6})$',
    RA000423: '^(\\d{11})$',
    RA000424: '^(\\d{11})$',
    RA000428: '^(FL-\\d{4}\\.\\d{3}\\.\\d{3}\\-\\d{1})$',
    RA000430: '^(\\d{9})$',
    RA000432: '^((B|E|I|J|0|S|A|F|G|K|D|M)\\d{1,6})$',
    RA000444: '^(\\d{1,6})$',
    RA000449: '^([A-ZÑ\\&]{3,4}\\s?-?\\s?\\d{6}[A-Z0-9]{3})$',
    RA000463: '^(\\d{8})$',
    RA000466: '^(\\d{1,7}|\\d{13})$',
    RA000472: '^(\\d{9})$|^(\\d{3}\\s\\d{3}\\s\\d{3})$',
    RA000473: '^(\\d{9})$|^(\\d{3}\\s\\d{3}\\s\\d{3})$',
    RA000484: '^(\\d{10})$',
    RA000486: '^(\\d{10})$',
    RA000487: '^(\\d{9})$',
    RA000497: '^([JFC]([0-3][0-9]|40|51|52|99)\\/\\d+\\/\\d{4})$|^(\\d{2,10})$',
    RA000498:
        '^([A-Z]{3}\\d{2}[A-Z]{4,5}\\/\\d{6})$|^([A-Z]{3}\\d{2}[A-Z]{7,10}\\d{4})$|^([A-Z0-9]{5}\\.\\d[A-Z]{4}(([AI]\\/\\d{6})|([A-Z]{6}\\d{4})))$|^(RA-\\d{3})$|^(SAP-RO-\\d{8})$|^(FP\\d-\\d{2,4})$',
    RA000529: '^(\\d{10})$',
    RA000531: '^(([A-Z]{1}\\d{10})$|^(\\d{4}\\/\\d{6}\\/\\d{2}))$',
    RA000534: '^(([A-Z]{1,6}-)?\\d{1,5}(-\\d{1,4})?)$',
    RA000544: '^(\\d{10}(\\ \\d{3})?)$|^(\\d{6}-\\d{4}(\\ \\d{3})?)$|^(\\d{14})$|^((\\d{6,8}-?\\d{4})(\\s?\\d{3})?)$',
    RA000546: '^((\\d{6}-\\d{4})|(\\d{10}))$',
    RA000548: '^((CHE-\\d{3}\\.\\d{3}\\.\\d{3})|(CHE-?\\d{9}))$',
    RA000549: '^((CHE-\\d{3}\\.\\d{3}\\.\\d{3})|(CHE-?\\d{9}))$',
    RA000554: '^(\\d{13})$',
    RA000585:
        '^(\\d{8})$|((AC|BR|CE|FC|GE|GN|GS|IC|IP|LP|NA|NC|NF|NI|NL|NO|NP|NR|NZ|OC|RC|RS|SA|SC|SG|SE|SF|SI|SL|SO|SP|SR|SZ|ZC)\\d{6})$|([R]\\d{7})|(IP\\d{5}R)$',
    RA000586:
        '^(\\d{8})$|((AC|BR|CE|FC|GE|GN|GS|IC|IP|LP|NA|NC|NF|NI|NL|NO|NP|NR|NZ|OC|RC|RS|SA|SC|SG|SE|SF|SI|SL|SO|SP|SR|SZ|ZC)\\d{6})$|([R]\\d{7})|(IP\\d{5}R)$',
    RA000587:
        '^(\\d{8})$|((AC|BR|CE|FC|GE|GN|GS|IC|IP|LP|NA|NC|NF|NI|NL|NO|NP|NR|NZ|OC|RC|RS|SA|SC|SG|SE|SF|SI|SL|SO|SP|SR|SZ|ZC)\\d{6})$|([R]\\d{7})|(IP\\d{5}R)$',
    RA000589: '^(\\d{6,8}(-\\d)?)$',
    RA000590: '^(SC\\d{6})$',
    RA000598: '^(\\d{12})$|^(C\\d{7})$',
    RA000599: '^(\\d{4})',
    RA000600: '^(\\d{7})$',
    RA000602: '^(\\d{5,7})$',
    RA000610: '^(\\d{1,7})$',
    RA000612: '^(\\d{8}[A-Za-z])$',
    RA000616: '^(\\d{6})$|^(\\d{9})$',
    RA000625: '^(\\d{10})$',
    RA000636: '^(\\d{9})$',
    RA000641: '^(\\d{3}\\s\\d{3}\\s\\d{3})$|^(\\d{9})$',
    RA000647: '^([1-9]\\d{1,5})$',
    RA000654: '^(\\d{9})$',
    RA000656: '^(\\d{2}-\\d{2}-\\d{7})$',
    RA000664: '^(\\d{9})$',
    RA000666: '^(\\d{1,3})$',
    RA000667: '^(\\d{1,6})$',
    RA000668: '^(\\d{1,6})$',
    RA000685: '^(\\d{12})$',
    RA000694: '^(\\d{7,8})$',
    RA000697: '^([A-Z]{2}[A-Z0-9]{9}[0-9])$',
    RA000707: '^(\\d{10})$|^(\\d{13})$',
    RA000708: '^([A-Z]{2}[A-Z0-9]{9}[0-9])$',
    RA000709: '^((\\d{10})|([A-Z]{5}[0-9]{4}[A-Z]))$',
    RA000710: '^(\\d{10})$|^(\\d{9})$',
    RA000713: '^((\\d{10})|([A-Z]{5}[0-9]{4}[A-Z]))$',
    RA000718: '^(\\d+\\/[ABCDE]\\/\\d{4})$',
    RA000719: '^(\\d{2,10})$',
    RA000720: '^(\\d{5})$',
    RA000721:
        '^(([A-Z]{2})-([A-Z]{3})-\\d{2}-\\d{3,6})$|^(([A-Z]{4})-([A-Z]{2})-\\d{2}-\\d{2}-\\d{4})$|^(([A-Z]{2})([A-Z]{2})?-([A-Z]{2})-\\d{4}(-([A-Z])-([A-Z]{2})-\\d{3})?)$',
    RA000735: '^((\\d{6}-\\d{4})|(\\d{10}))$',
    RA000754: '^[0-9A-Z]{15}$'
};

const leiRejstrikValidation = (rejstrikVal: string) => {
    const currentRegex = new RegExp(_getKeyValue_(rejstrikVal)(leiRejstrikRegExp));

    if (CZSKrejstrikVals.includes(rejstrikVal)) {
        // validacia pre CZ/
        return icoValidation();
    } else if (String(currentRegex) !== '/(?:)/') {
        // validacia z currentRegex
        return [
            () => ({
                validator(_rule: RuleObject, value: string) {
                    if (!value || currentRegex.test(value)) return Promise.resolve();
                    return Promise.reject(<TranslateText>NEVALIDNI_ICO</TranslateText>);
                }
            })
        ];
    }
    // validacia ak sa nenachadza v currentRegex
    return icoZahranicnyValidation();
};
export default leiRejstrikValidation;
